var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanCamp1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 191,
    viewBox: "0 0 194 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.733 15.3269C137.24 15.0127 140.17 15.0537 142.819 16.7839C145.13 18.2932 146.402 20.5883 147.249 22.5037L147.587 23.2986L147.844 23.9373C150.293 30.1897 151.78 38.7542 153.021 44.616L153.275 45.7888V45.7898C159.103 72.1356 163.4 97.8196 169.949 123.494C171.083 127.939 172.517 132.491 173.958 137.369C175.37 142.146 176.759 147.149 177.625 152.063C178.193 155.289 178.949 159.939 178.153 164.24C177.734 166.502 176.853 168.898 175.123 171.008C173.656 172.796 171.758 174.156 169.496 175.077L168.749 175.825H162.79L162.353 175.755L99.7134 165.616L99.6157 165.599L99.5181 165.58C87.9697 163.28 76.1425 161.57 64.104 159.707C52.1332 157.854 40.0077 155.858 28.1909 153.004V153.003C25.9235 152.456 21.3369 151.708 17.7358 149.053L15.4995 147.405V142.358L15.647 141.734C21.0615 118.847 29.3634 96.9864 43.5015 77.533L44.4302 76.2664C64.0225 49.7981 89.1349 31.1343 120.119 19.8347V19.8337C121.746 19.2399 124.292 18.2663 126.735 17.4275C129.12 16.6084 131.933 15.7281 134.238 15.3933L134.733 15.3269Z",
    fill: "#FBB733",
    stroke: "white",
    strokeWidth: 11
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_49",
    x: 9.99951,
    y: 9.67505,
    width: 177.996,
    height: 180.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_49",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanCamp1);
export default __webpack_public_path__ + "static/media/banCamp1.bcedbec4c6f0574052e96afad4efa6d9.svg";
export { ForwardRef as ReactComponent };